import * as resource from './resources'

export default {
  localLogin: function (data) {
    return resource.Authenticate(data)
  },

  // COACH
  getCoachList: function () {
    return resource.CoachResource.get(null)
  },

  saveCoach: function (data) {
    return resource.CoachResource.save(null, data)
  },

  getCoach: function (id) {
    return resource.CoachResource.query({id: id})
  },

  updateCoach: function (id, data) {
    return resource.CoachResource.update({id: id}, data)
  },

  deleteCoach: function (id) {
    return resource.CoachResource.delete({id: id})
  },

  updateCoachScreensaver: function (data) {
    return resource.CoachScreensaver(data)
  },

  updateCoachState: function (data) {
    return resource.CoachState(data)
  },

  // MENU
  getCategoryList: function (id) {
    return resource.ListCoachCategory(id)
  },

  categoryCoach: function (data) {
    return resource.CoachCategory(data)
  },

  updateCategoryCoachState: function (data) {
    return resource.updateCategoryCoachState(data)
  },

  categoryCoachRemove: function (data) {
    return resource.CoachCategoryRemove(data)
  },

  // SLIDE
  getSlideList: function (data) {
    return resource.SlideResource.get(data)
  },

  saveSlide: function (data) {
    return resource.SlideResource.save(null, data)
  },

  reorderSlides: function (data) {
    return resource.reorderSlides(data)
  },

  updateSlide: function (id, data) {
    return resource.SlideResource.update({id: id}, data)
  },

  deleteSlide: function (id) {
    return resource.SlideResource.delete({id: id})
  },

  updateSlideState: function (data) {
    return resource.SlideState(data)
  },

  // SUB SLIDE
  setSubSlideCategory (data) {
    return resource.setSubSlideCategory(data)
  },

  deleteSubSlideCategory (data) {
    return resource.deleteSubSlideCategory(data)
  },

  updateSubSlideCategory (data) {
    return resource.updateSubSlideCategory(data)
  },

  // PANORAMA
  getPanorama: function (id) {
    return resource.PanoramaResource.query({id: id})
  },

  updatePanorama: function (id, data) {
    return resource.PanoramaResource.update({id: id}, data)
  },

  savePanoramaPoint: function (data) {
    return resource.PanoramaPointResource.save(null, data)
  },

  updatePanoramaPoint: function (id, data) {
    return resource.PanoramaPointResource.update({id: id}, data)
  },

  deletePanoramaPoint: function (id) {
    return resource.PanoramaPointResource.delete({id: id})
  },

  deletePanoramaCube: function (id, position) {
    return resource.PanoramaCubeResource.delete({id: id, position: position})
  },

  // EXTERIOR
  getExteriorsList: function (id, data) {
    return resource.ExteriorResource.query({id: id}, data)
  },

  saveExterior: function (data) {
    return resource.ExteriorResource.save(null, data)
  },

  getExterior: function (id) {
    return resource.ExteriorResource.query({id: id})
  },

  updateExterior: function (id, data) {
    return resource.ExteriorResource.update({id: id}, data)
  },

  deleteExterior: function (id) {
    return resource.ExteriorResource.delete({id: id})
  },

  reorderExteriors: function (data) {
    return resource.reorderExteriors(data)
  },

  updateExteriorState: function (data) {
    return resource.ExteriorState(data)
  },

  // USER
  getUserList: function () {
    return resource.UserResource.get(null)
  },

  updateUser: function (id, data) {
    return resource.UserResource.update({id: id}, data)
  },

  saveUser: function (data) {
    return resource.UserResource.save(null, data)
  },

  deleteUser: function (id) {
    return resource.UserResource.delete({id: id})
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js